import { connect } from 'react-redux'
import { getProp } from '../../../../../../redux/selectors/kegCollectionBookings'
import KegCollectionEditModal from './KegCollectionEditModal'

const mapStateToProps = state => {
  const {
    bookingDetails: { editKegCollectionRequestStatusState },
  } = getProp(state)
  return {
    editKegCollectionRequestStatusState,
  }
}

export default connect(mapStateToProps)(KegCollectionEditModal)
